import {
  DashboardResponse,
  LoginAndGetDashboardResponse
} from '../models/dashboard.interfaces';
import { dashboardErrorMocks } from './dashboard-errors.mocks';

export const dashboardResponseMocks: Partial<DashboardResponse> = {
  smNumber: '8006270311',
  firstName: 'Rocky',
  lastName: 'Olive',
  smBalance: '38000',
  membershipLevel: 'DM',
  enrollmentDate: '2004-05-27',
  prefix: 'Mr',
  primaryEmailAddress: 'test.tesing@delta.com',
  preferredName: 'FR',
  medallionMemberDesc: 'Diamond Medallion',
  medallionMbrInd: '0',
  country: 'US',
  language: 'EN',
  customerID: '0008006270311',
  MQMBalance: '0',
  loyaltyPromoInd: 'Y',
  loyaltyPromoLink: '/mypromos/displayPromotions',
  sysDrvdPrefHomeArptCd: 'MSP',
  usrProvdPrefHomeArptCd: 'JFK',
  crprtAgrmntId: '7814792|3000000008072|US123456789',
  crprtAgrmntTypeCode: 'CNA|CNA|SME',
  crprtPricingDiscCode: '579EQ00|4BW0F00| ',
  crprtName: '2CHECKOUT|GOOGLE|TAI',
  cobrandCardtypeList: 'AXCV',
  adminCompanyName: 'NA|NA|NA',
  smeCompanyName: 'tai',
  smeCardTypes: 'SKYB',
  skyPriority: true,
  pwmMbr: false,
  crprtAgrmntFound: true,
  skymilesMember: true,
  langPromptIndicator: false,
  rememberMeIndicator: false,
  millionMiler: false,
  irop: false,
  spgInd: false,
  firstTime: true,
  hasUserNm: false,
  is360Tier: false,
  isAbove18: false,
  promoCdInd: false,
  loggedIn: true,
  isWarmState: false,
  hasSQA: true,
  hasEmail: true,
  hasPhone: true,
  hasTripLink: 'N',
  hasNuTvl: 'N',
  permType: 'NA|NA|NA',
  pgmType: 'NA|NA|NA',
  accessToken: 'NA|NA|NA',
  userId: 'NA|NA|NA',
  program: 'NONE|CSA|SKYB',
  contractMgtEnt: 'NA|NAM|NA',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  formNameSubmitted: '',
  isEmailValid: true,
  middleName: '',
  milesExpireDate: '',
  millionMilerTier: '',
  nameSuffix: '',
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeLastName: '',
  spid: '',
  triplinkErrorCd: '',
  userNameType: '',
  venderID: '',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  skyClubMembershipDiscontinueDate: '2025-09-05',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: ''
};

export const dashboardResponseFullMocks: DashboardResponse = {
  smNumber: '8006270311',
  firstName: 'Coco',
  lastName: 'Olive',
  smBalance: '820',
  membershipLevel: 'DM',
  enrollmentDate: '2014-05-27',
  prefix: 'Mr',
  primaryEmailAddress: 'test.tesing@delta.com',
  preferredName: 'FR',
  isAbove18: true,
  medallionMemberDesc: 'Diamond Medallion',
  medallionMbrInd: '1',
  country: 'US',
  language: 'EN',
  customerID: '0008006270311',
  MQMBalance: '0',
  loyaltyPromoInd: 'Y',
  loyaltyPromoLink: '/mypromos/displayPromotions',
  sysDrvdPrefHomeArptCd: 'MSP',
  usrProvdPrefHomeArptCd: 'JFK',
  crprtAgrmntId: '7814792|3000000008072|US123456789',
  crprtAgrmntTypeCode: 'CNA|CNA|SME',
  crprtPricingDiscCode: '579EQ00|4BW0F00| ',
  crprtName: '2CHECKOUT|GOOGLE|TAI',
  adminCompanyName: 'NA|NA|NA',
  smeCompanyName: 'tai',
  smeCardTypes: 'SKYB',
  skyPriority: true,
  pwmMbr: false,
  crprtAgrmntFound: true,
  skymilesMember: true,
  langPromptIndicator: false,
  rememberMeIndicator: false,
  millionMiler: false,
  irop: false,
  spgInd: false,
  firstTime: true,
  hasUserNm: false,
  is360Tier: false,
  promoCdInd: false,
  loggedIn: true,
  isWarmState: false,
  hasSQA: true,
  hasEmail: true,
  hasTripLink: 'N',
  hasNuTvl: 'N',
  hasPhone: true,
  permType: 'NA|NA|NA',
  pgmType: 'NA|NA|NA',
  accessToken: 'NA|NA|NA',
  userId: 'NA|NA|NA',
  program: 'NONE|CSA|SKYB',
  contractMgtEnt: 'NA|NAM|NA',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  formNameSubmitted: '',
  isEmailValid: true,
  middleName: '',
  milesExpireDate: '',
  millionMilerTier: '',
  nameSuffix: '',
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeLastName: '',
  spid: '',
  triplinkErrorCd: '',
  userNameType: '',
  venderID: '',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  skyClubMembershipDiscontinueDate: '2025-09-05',
  errors: [dashboardErrorMocks],
  emailAddressLocalDate: '2024-04-18',
  hasTravelPolicy: '',
  cobrandCardtypeAffiliationIdList: '840032888460:840052869646',
  cobrandCardtypeDescList:
    'Delta SkyMiles Reserve Card:Delta SkyMiles Reserve Business Card',
  cobrandCardtypeList: 'AXCV:AXBV',
  cobrandCardtypeSkyclubEligibleList: 'false:false'
};

export const LoginAndGetDashboardResponseMocks: Partial<LoginAndGetDashboardResponse> =
  {
    smNumber: '8001590739',
    firstName: 'Ping',
    lastName: 'Test',
    smBalance: '0',
    membershipLevel: 'FF',
    enrollmentDate: '2021-11-17',
    primaryEmailAddress: 'test123@gmail.com',
    country: 'US',
    language: 'en',
    customerID: '0008001590739',
    MQMBalance: '0',
    loyaltyPromoInd: 'N',
    loyaltyPromoLink: '',
    sysDrvdPrefHomeArptCd: 'ATL',
    skyPriority: false,
    pwmMbr: false,
    crprtAgrmntFound: false,
    skymilesMember: true,
    langPromptIndicator: false,
    rememberMeIndicator: false,
    millionMiler: false,
    irop: false,
    spgInd: false,
    firstTime: true,
    hasUserNm: false,
    is360Tier: false,
    promoCdInd: false,
    loggedIn: true,
    isWarmState: false,
    hasSQA: true,
    hasEmail: true,
    isEmailValid: true,
    refreshURL: 'https://st.delta.com/',
    isLoggedIn: true,
    smType: 'BaseSm',
    loginMethod: 'Skymiles',
    isBusiness: false,
    queryParams:
      'ping=true|login_tokenId=2152bd0e-fbc5-46a5-a803-4ee01e171ad5|login_username=username|login_password=password|login_lastName=lastName|login_isPersistent=true|login_refreshURL=https%3A%2F%2Fst.delta.com%2F',
    emailAddressLocalDate: '2021-11-17'
  };
